(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8542],{

/***/ 91630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TrustpilotFeedBack; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/gr/GrFormNext.js

function GrFormNext(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "9 6 15 12 9 18"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Icon/si/SiTrustpilot.js
var SiTrustpilot = __webpack_require__(9633);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/Index.module.scss
var Index_module = __webpack_require__(29850);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/TrustpilotFeedBack/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var dataStar = new Array(5).fill(1);
var swiper = {
  preloadImages: false,
  lazy: true,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".swiper-trustpilot-dots",
    clickable: true,
    bulletClass: "bbc-pagination-bullet",
    bulletActiveClass: "bbc-pagination-bullet-active"
  },
  navigation: {
    nextEl: ".swiper-trustpilot-next",
    prevEl: ".swiper-trustpilot-prev"
  },
  slidesPerView: 1,
  spaceBetween: 40
};

var Component = function Component(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(null),
      thumbsSwiper = _useState[0],
      setThumbsSwiper = _useState[1];

  function isImage(url) {
    // eslint-disable-next-line prefer-named-capture-group
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-6 justify-between lg:mt-10 lg:flex",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 lg:col-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, _objectSpread(_objectSpread({
        spaceBetween: 10,
        thumbs: {
          swiper: thumbsSwiper
        },
        modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Navigation */.W_, swiper_esm/* Thumbs */.o3, swiper_esm/* Pagination */.tl]
      }, swiper), {}, {
        className: "swiperFeelback bg-bbc-main ",
        children: data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: "p-3 lg:p-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: " w-full rounded-3xl bg-white py-6 px-8 shadow-[0px_0px_12px_rgba(119,119,119,0.25)] lg:rounded-none  lg:bg-transparent lg:p-0 lg:shadow-none",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center lg:justify-start",
                children: [isImage(item.avatar) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: item.avatar,
                  className: "mr-6 rounded-full",
                  alt: item.name,
                  width: 80,
                  height: 80
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat((Index_module_default()).avatar, " mr-6 flex items-center justify-center rounded-full font-bold"),
                  style: {
                    backgroundColor: item.bgAvatar
                  },
                  children: item.avatar
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "mb-2  text-bbc-neutral-700",
                    children: item.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex",
                    children: dataStar.map(function (item, index) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "mr-1 flex h-6 w-6 items-center justify-center bg-[#00b67a] shadow-md",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
                          className: "text-xl text-bbc-white"
                        })
                      }, index);
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "align-items-end mt-3  flex",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "mr-0.5",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
                        className: "text-2xl text-[#00b67a]"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "text-xl font-medium text-bbc-black",
                      children: "Trustpilot"
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "my-4 text-center font-semibold text-[#0042A3] opacity-[0.8] lg:text-left",
                children: item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: " text-center text-bbc-gray lg:text-left",
                children: item.content
              })]
            })
          }, index);
        })
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative  text-center lg:col-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " hidden lg:flex lg:justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
          onSwiper: setThumbsSwiper,
          spaceBetween: 5,
          slidesPerView: 3,
          freeMode: true,
          allowTouchMove: false,
          modules: [swiper_esm/* FreeMode */.Rv, swiper_esm/* Navigation */.W_, swiper_esm/* Thumbs */.o3, swiper_esm/* Pagination */.tl],
          className: "swiperAvatar col-5 mr-2.5 ml-0",
          children: data.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
              className: "text-center",
              children: isImage(item.avatar) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: item.avatar,
                className: "cursor-pointer rounded-full",
                alt: "avatar",
                width: 60,
                height: 60
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mx-auto flex  items-center justify-center rounded-full text-2xl font-bold",
                style: {
                  width: "60px",
                  height: "60px",
                  backgroundColor: item.bgAvatar
                },
                children: item.avatar
              })
            }, index);
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " mt-6 hidden h-16 lg:block",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "swiper-trustpilot-next absolute flex h-16 w-16 cursor-pointer items-center justify-center rounded-full ".concat((Index_module_default()).btnNext, " "),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GrFormNext, {
            className: " text-3xl"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "swiper-trustpilot-prev absolute  flex h-16 w-16 cursor-pointer items-center justify-center rounded-full ".concat((Index_module_default()).btnPrev, " "),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GrFormNext, {
            className: "rotate-180 text-3xl"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "swiper-trustpilot-dots  pt-6 "
      })]
    })]
  });
};

/* harmony default export */ var TrustpilotFeedBack = (Component);

/***/ }),

/***/ 25637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/** ========== */





var WhyChooseUs = function WhyChooseUs(_ref) {
  var title = _ref.title,
      data = _ref.data,
      sectionClassName = _ref.sectionClassName,
      note = _ref.note,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("section", {
    className: sectionClassName,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        children: [note && note.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "title-h2 mb-4 text-center text-white lg:mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
            className: "mb-10 text-center text-white",
            dangerouslySetInnerHTML: {
              __html: note
            }
          })]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "title-h2 mb-4 text-center text-white lg:mb-10"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "row justify-center gap-y-6 lg:gap-y-10",
          children: data.length > 0 && data.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
              className: "col-12 ".concat(data.length === 4 ? "lg:col-3" : "lg:col-4"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                className: "text-center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                  src: item.icon.src,
                  alt: item.icon.altText,
                  width: 48,
                  height: 48,
                  wrapper: {
                    className: "flex items-center justify-center bg-white rounded-[26px] h-20 w-20  mx-auto"
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                  className: "flex justify-center",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    as: "h3",
                    text: item.title,
                    className: "mt-6 w-5/6 text-lg font-semibold normal-case text-white"
                  })
                }), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                  className: "mt-3 !normal-case text-white",
                  children: item.description
                })]
              })
            }, index);
          })
        })]
      })
    }), children]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (WhyChooseUs);
WhyChooseUs.defaultProps = {
  title: "",
  data: [],
  sectionClassName: ""
};
/** ========== */

/***/ }),

/***/ 58542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./common/data/trustpilot/data.json
var data = __webpack_require__(54356);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/index.js + 1 modules
var TrustpilotFeedBack = __webpack_require__(91630);
// EXTERNAL MODULE: ./components/organisms/WhyChooseUs/index.js
var WhyChooseUs = __webpack_require__(25637);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/about-us/OurCoreValues/index.js






var CoreValueItem = function CoreValueItem(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex items-center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mr-4",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: data.icon.src,
        alt: data.icon.altText,
        width: data.icon.width || 48,
        height: data.icon.height || 48,
        className: "h-full w-full",
        wrapper: {
          className: "block w-12"
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        as: "h6",
        text: data.title,
        className: "mb-4 text-lg font-semibold text-bbc-brand-700"
      }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-black ",
        children: data.description
      })]
    })]
  });
};

var OurCoreValues = function OurCoreValues(_ref2) {
  var title = _ref2.title,
      description = _ref2.description,
      data = _ref2.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container relative z-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        text: title,
        className: "title-h2 mb-6 text-center text-bbc-brand-800 lg:text-left"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-4 lg:mb-10",
        children: description
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "row justify-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "order-last space-y-10 lg:col-6 lg:order-first",
          children: data.values.length > 0 && data.values.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(CoreValueItem, {
              data: item
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "item-center mb-5 flex justify-center lg:col-6 lg:mb-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: data.image.src,
            alt: data.image.altText,
            width: data.image.width || 472,
            height: data.image.height || 533,
            className: "h-full w-full",
            wrapper: {
              className: "block  py-6",
              style: {
                width: "472px"
              }
            }
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var about_us_OurCoreValues = (OurCoreValues);
OurCoreValues.defaultProps = {
  title: "",
  description: "",
  data: {}
};
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(68216);
;// CONCATENATED MODULE: ./components/templates/offshore/about-us/OurPartners/BubbleLogoRunner/Bubble.js



/* eslint-disable */
var Bubble = function Bubble(id, row, col, top, left, scale) {
  var _this = this;

  (0,classCallCheck/* default */.Z)(this, Bubble);

  (0,defineProperty/* default */.Z)(this, "init", function () {
    var bubbleDom = document.getElementById("bubble-item-".concat(_this.id));

    if (bubbleDom) {
      _this.runnerX = 0;
      _this.runnerY = bubbleDom.offsetTop;
      _this.specificTop = bubbleDom.offsetTop;
      _this.specificLeft = bubbleDom.offsetLeft;
      bubbleDom.style.opacity = 1;
      _this.bubbleDom = bubbleDom;
    }
  });

  (0,defineProperty/* default */.Z)(this, "update", function (panelScrollHeight) {
    if (_this.bubbleDom) {
      if (_this.runnerY > -1 * _this.bubbleDom.offsetHeight) {
        if (_this.mode < 0) {
          _this.mode = _this.runnerX < -5 ? 1 : -1;
        }

        if (_this.mode > 0) {
          _this.mode = _this.runnerX <= 5 ? 1 : -1;
        }

        _this.runnerX += _this.mode / (20 * _this.scale);
        _this.runnerY -= 1;
        _this.bubbleDom.style.top = "".concat(_this.runnerY, "px");
        _this.bubbleDom.style.transform = "translateX(".concat(_this.runnerX, "px) scale(").concat(_this.scale, ")");
      } else {
        _this.runnerY = panelScrollHeight - _this.bubbleDom.offsetHeight;
      }
    }
  });

  this.id = id;
  this.row = row;
  this.col = col;
  this.left = left;
  this.top = top;
  this.scale = scale;
  this.mode = id % 2 === 0 ? 1 : -1;
};
;// CONCATENATED MODULE: ./components/templates/offshore/about-us/OurPartners/BubbleLogoRunner/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/* Component */

/* ********** */
// Const bubbles = [
//   // 1
//   New Bubble(1, 0, 0, "0px", "0%", 0.75),
//   New Bubble(2, 0, 1, "120px", "25%", 0.5),
//   New Bubble(3, 0, 2, "25px", "65%", 1),
//   New Bubble(4, 0, 3, "220px", "55%", 0.75),
//   New Bubble(5, 0, 4, "280px", "15%", 0.5),
//   New Bubble(6, 0, 5, "350px", "75%", 0.75),
//   // // 2
//   New Bubble(7, 1, 0, "490px", "45%", 1),
//   New Bubble(8, 1, 1, "420px", "0%", 0.75),
//   New Bubble(9, 1, 2, "600px", "0%", 0.5),
//   New Bubble(10, 1, 3, "650px", "70%", 0.75),
//   New Bubble(11, 1, 4, "700px", "30%", 0.75),
//   New Bubble(12, 1, 5, "830px", "0%", 1),
//   // // 3
//   New Bubble(13, 2, 0, "800px", "70%", 0.5),
//   New Bubble(14, 2, 1, "920px", "45%", 0.75),
//   New Bubble(15, 2, 2, "1020px", "10%", 0.5),
//   New Bubble(16, 2, 3, "1050px", "70%", 0.5),
//   New Bubble(17, 2, 4, "1170px", "45%", 1),
//   New Bubble(18, 2, 5, "1200px", "0%", 0.75),
//   // // 4
//   New Bubble(19, 3, 0, "1320px", "70%", 0.75),
//   New Bubble(20, 3, 1, "1340px", "20%", 0.5),
//   New Bubble(21, 3, 2, "1450px", "45%", 0.5),
//   New Bubble(22, 3, 3, "1500px", "0%", 1),
//   New Bubble(23, 3, 4, "1670px", "20%", 0.5),
//   New Bubble(24, 3, 5, "1620px", "65%", 0.75),
//   // // 5
//   New Bubble(25, 4, 0, "1790px", "0%", 0.75),
//   New Bubble(26, 4, 1, "1820px", "60%", 1),
//   New Bubble(27, 4, 2, "1950px", "10%", 0.5),
//   New Bubble(28, 4, 3, "1990px", "60%", 0.5),
//   New Bubble(29, 4, 4, "2120px", "10%", 1),
//   New Bubble(30, 4, 5, "2150px", "60%", 0.75),
//   // // 6
//   New Bubble(31, 5, 0, "2280px", "35%", 0.5),
// ];


var bubbles = [// // 1
new Bubble(1, 0, 0, "150px", "86%", 0.75), new Bubble(2, 0, 1, "330px", "42%", 0.5), new Bubble(3, 0, 2, "380px", "28%", 0.6), new Bubble(4, 0, 3, "430px", "60%", 0.75), new Bubble(5, 0, 4, "490px", "17%", 0.5), new Bubble(6, 0, 5, "550px", "75%", 0.75), // // 2
new Bubble(7, 1, 0, "570px", "40%", 1), new Bubble(8, 1, 1, "600px", "0%", 0.75), new Bubble(9, 1, 2, "175px", "0%", 0.6), new Bubble(10, 1, 3, "680px", "60%", 0.75), new Bubble(11, 1, 4, "700px", "25%", 0.75), new Bubble(12, 1, 5, "830px", "45%", 1), // // 3
// New Bubble(13, 2, 0, "800px", "75%", 0.5),
new Bubble(14, 2, 1, "900px", "15%", 0.75), new Bubble(15, 2, 2, "1020px", "2%", 0.5), new Bubble(16, 2, 3, "360px", "85%", 0.6), new Bubble(17, 2, 4, "350px", "10%", 0.6), new Bubble(18, 2, 5, "1020px", "70%", 0.75), // // 4
new Bubble(19, 3, 0, "1050px", "40%", 0.75), new Bubble(20, 3, 1, "1140px", "20%", 0.5), new Bubble(21, 3, 2, "1170px", "85%", 0.5), new Bubble(22, 3, 3, "1200px", "60%", 1), new Bubble(23, 3, 4, "285px", "60%", 0.6), new Bubble(24, 3, 5, "120px", "50%", 0.75), // // 5
new Bubble(25, 4, 0, "190px", "30%", 0.6), new Bubble(26, 4, 1, "190px", "15%", 1), new Bubble(27, 4, 2, "1250px", "10%", 0.5), new Bubble(28, 4, 3, "220px", "75%", 0.7), new Bubble(29, 4, 4, "1300px", "35%", 1), new Bubble(30, 4, 5, "1360px", "75%", 0.75), // // 6
new Bubble(31, 5, 0, "75px", "65%", 0.6)];

var BubbleElement = function BubbleElement(_ref) {
  var item = _ref.item,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  var jump = 905;
  var size = 150;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "bubble-item-".concat(item.id),
    className: "shadow-bbc bubble-item absolute inline-block rounded-full bg-no-repeat transition-opacity duration-700",
    style: _objectSpread({
      backgroundImage: "url(/assets/images/common/logo-bubbles.png)",
      backgroundPosition: "".concat(-1 * (size * item.col + item.col), "px ").concat(-1 * (size * item.row + item.row), "px"),
      backgroundSize: "".concat(jump, "px ").concat(jump, "px"),
      width: size,
      height: size,
      opacity: 0,
      left: item.left,
      top: item.top,
      transform: "scale(".concat(item.scale, ")")
    }, style)
  });
};

var BubbleLogoRunner = function BubbleLogoRunner(_ref2) {
  var className = _ref2.className;
  var timer = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var bubblePanel = document.getElementById("bubble-panel");

    if (bubblePanel) {
      bubbles.forEach(function (item) {
        item.init();
      });
      var panelScrollHeight = bubblePanel.scrollHeight;

      var test = function test() {
        bubbles.forEach(function (item) {
          item.update(panelScrollHeight);
        });
      };

      timer.current = setInterval(test, 25);
      return function () {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        clearInterval(timer.current);
      };
    }
  }, []); // ******

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative flex  justify-center overflow-hidden",
      style: {
        height: "430px"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "bubble-panel",
        className: "relative h-full w-full",
        children: bubbles.map(function (item, itemIdx) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(BubbleElement, {
            item: item
          }, itemIdx);
        })
      })
    })
  });
};

/* harmony default export */ var OurPartners_BubbleLogoRunner = (BubbleLogoRunner);
BubbleLogoRunner.defaultProps = {};
;// CONCATENATED MODULE: ./components/templates/offshore/about-us/OurPartners/BubbleLogoRunnerMobile/Bubble.js



/* eslint-disable */
var Bubble_Bubble = function Bubble(id, row, col, top, left, scale) {
  var _this = this;

  (0,classCallCheck/* default */.Z)(this, Bubble);

  (0,defineProperty/* default */.Z)(this, "init", function () {
    var bubbleDom = document.getElementById("bubble-mobile-item-".concat(_this.id));

    if (bubbleDom) {
      _this.runnerX = 0;
      _this.runnerY = bubbleDom.offsetTop;
      _this.specificTop = bubbleDom.offsetTop;
      _this.specificLeft = bubbleDom.offsetLeft;
      bubbleDom.style.opacity = 1;
      _this.bubbleDom = bubbleDom;
    }
  });

  (0,defineProperty/* default */.Z)(this, "update", function (panelScrollHeight) {
    if (_this.bubbleDom) {
      if (_this.runnerY > -1 * _this.bubbleDom.offsetHeight) {
        if (_this.mode < 0) {
          _this.mode = _this.runnerX < -5 ? 1 : -1;
        }

        if (_this.mode > 0) {
          _this.mode = _this.runnerX <= 5 ? 1 : -1;
        }

        _this.runnerX += _this.mode / (20 * _this.scale);
        _this.runnerY -= 1;
        _this.bubbleDom.style.top = "".concat(_this.runnerY, "px");
        _this.bubbleDom.style.transform = "translateX(".concat(_this.runnerX, "px) scale(").concat(_this.scale, ")");
      } else {
        _this.runnerY = panelScrollHeight - _this.bubbleDom.offsetHeight;
      }
    }
  });

  this.id = id;
  this.row = row;
  this.col = col;
  this.left = left;
  this.top = top;
  this.scale = scale;
  this.mode = id % 2 === 0 ? 1 : -1;
};
;// CONCATENATED MODULE: ./components/templates/offshore/about-us/OurPartners/BubbleLogoRunnerMobile/index.js


function BubbleLogoRunnerMobile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function BubbleLogoRunnerMobile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BubbleLogoRunnerMobile_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BubbleLogoRunnerMobile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/* Component */

/* ********** */
// Const bubbles = [
//   // 1
//   New Bubble(1, 0, 0, "0px", "0%", 0.75),
//   New Bubble(2, 0, 1, "120px", "25%", 0.5),
//   New Bubble(3, 0, 2, "25px", "65%", 1),
//   New Bubble(4, 0, 3, "220px", "55%", 0.75),
//   New Bubble(5, 0, 4, "280px", "15%", 0.5),
//   New Bubble(6, 0, 5, "350px", "75%", 0.75),
//   // // 2
//   New Bubble(7, 1, 0, "490px", "45%", 1),
//   New Bubble(8, 1, 1, "420px", "0%", 0.75),
//   New Bubble(9, 1, 2, "600px", "0%", 0.5),
//   New Bubble(10, 1, 3, "650px", "70%", 0.75),
//   New Bubble(11, 1, 4, "700px", "30%", 0.75),
//   New Bubble(12, 1, 5, "830px", "0%", 1),
//   // // 3
//   New Bubble(13, 2, 0, "800px", "70%", 0.5),
//   New Bubble(14, 2, 1, "920px", "45%", 0.75),
//   New Bubble(15, 2, 2, "1020px", "10%", 0.5),
//   New Bubble(16, 2, 3, "1050px", "70%", 0.5),
//   New Bubble(17, 2, 4, "1170px", "45%", 1),
//   New Bubble(18, 2, 5, "1200px", "0%", 0.75),
//   // // 4
//   New Bubble(19, 3, 0, "1320px", "70%", 0.75),
//   New Bubble(20, 3, 1, "1340px", "20%", 0.5),
//   New Bubble(21, 3, 2, "1450px", "45%", 0.5),
//   New Bubble(22, 3, 3, "1500px", "0%", 1),
//   New Bubble(23, 3, 4, "1670px", "20%", 0.5),
//   New Bubble(24, 3, 5, "1620px", "65%", 0.75),
//   // // 5
//   New Bubble(25, 4, 0, "1790px", "0%", 0.75),
//   New Bubble(26, 4, 1, "1820px", "60%", 1),
//   New Bubble(27, 4, 2, "1950px", "10%", 0.5),
//   New Bubble(28, 4, 3, "1990px", "60%", 0.5),
//   New Bubble(29, 4, 4, "2120px", "10%", 1),
//   New Bubble(30, 4, 5, "2150px", "60%", 0.75),
//   // // 6
//   New Bubble(31, 5, 0, "2280px", "35%", 0.5),
// ];


var BubbleLogoRunnerMobile_bubbles = [// 1
new Bubble_Bubble(1, 0, 0, "270px", "0%", 0.75), new Bubble_Bubble(2, 0, 1, "350px", "30%", 0.5), new Bubble_Bubble(3, 0, 2, "420px", "60%", 0.7), new Bubble_Bubble(4, 0, 3, "450px", "5%", 0.75), new Bubble_Bubble(5, 0, 4, "550px", "55%", 0.5), new Bubble_Bubble(6, 0, 5, "590px", "10%", 0.75), // // 2
new Bubble_Bubble(7, 1, 0, "660px", "60%", 0.75), new Bubble_Bubble(8, 1, 1, "750px", "30%", 0.75), new Bubble_Bubble(9, 1, 2, "100px", "0%", 0.6), new Bubble_Bubble(10, 1, 3, "720px", "0%", 0.6), new Bubble_Bubble(11, 1, 4, "860px", "60%", 0.75), new Bubble_Bubble(12, 1, 5, "890px", "0%", 1), // // 3
// New Bubble(13, 2, 0, "950px", "35%", 0.5),
new Bubble_Bubble(14, 2, 1, "1030px", "60%", 0.75), new Bubble_Bubble(15, 2, 2, "1020px", "15%", 0.5), new Bubble_Bubble(16, 2, 3, "1100px", "0%", 0.5), new Bubble_Bubble(17, 2, 4, "1170px", "35%", 1), new Bubble_Bubble(18, 2, 5, "1270px", "0%", 0.75), // // 4
new Bubble_Bubble(19, 3, 0, "1290px", "60%", 0.75), new Bubble_Bubble(20, 3, 1, "1340px", "28%", 0.5), new Bubble_Bubble(21, 3, 2, "1400px", "50%", 0.5), new Bubble_Bubble(22, 3, 3, "1450px", "2%", 1), new Bubble_Bubble(23, 3, 4, "80px", "60%", 0.6), new Bubble_Bubble(24, 3, 5, "245px", "60%", 0.75), // // 5
new Bubble_Bubble(25, 4, 0, "0px", "25%", 0.6), new Bubble_Bubble(26, 4, 1, "175px", "23%", 0.7), new Bubble_Bubble(27, 4, 2, "1500px", "40%", 0.5), new Bubble_Bubble(28, 4, 3, "1550px", "65%", 0.5), new Bubble_Bubble(29, 4, 4, "1630px", "10%", 1), new Bubble_Bubble(30, 4, 5, "1680px", "55%", 0.75), // // 6
new Bubble_Bubble(31, 5, 0, "1770px", "0%", 0.5)];

var BubbleLogoRunnerMobile_BubbleElement = function BubbleElement(_ref) {
  var item = _ref.item,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  var jump = 905;
  var size = 150;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "bubble-mobile-item-".concat(item.id),
    className: "shadow-bbc bubble-item absolute inline-block rounded-full bg-no-repeat transition-opacity duration-700",
    style: BubbleLogoRunnerMobile_objectSpread({
      backgroundImage: "url(/assets/images/common/logo-bubbles.png)",
      backgroundPosition: "".concat(-1 * (size * item.col + item.col), "px ").concat(-1 * (size * item.row + item.row), "px"),
      backgroundSize: "".concat(jump, "px ").concat(jump, "px"),
      width: size,
      height: size,
      opacity: 0,
      left: item.left,
      top: item.top,
      transform: "scale(".concat(item.scale, ")")
    }, style)
  });
};

var BubbleLogoRunnerMobile = function BubbleLogoRunnerMobile(_ref2) {
  var className = _ref2.className;
  var timer = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var bubblePanel = document.getElementById("bubble-mobile-panel");

    if (bubblePanel) {
      BubbleLogoRunnerMobile_bubbles.forEach(function (item) {
        item.init();
      });
      var panelScrollHeight = bubblePanel.scrollHeight;

      var test = function test() {
        BubbleLogoRunnerMobile_bubbles.forEach(function (item) {
          item.update(panelScrollHeight);
        });
      };

      timer.current = setInterval(test, 25);
      return function () {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        clearInterval(timer.current);
      };
    }
  }, []); // ******

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative flex justify-center overflow-hidden",
      style: {
        height: "430px"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "bubble-mobile-panel",
        className: "relative h-full w-full",
        children: BubbleLogoRunnerMobile_bubbles.map(function (item, itemIdx) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(BubbleLogoRunnerMobile_BubbleElement, {
            item: item
          }, itemIdx);
        })
      })
    })
  });
};

/* harmony default export */ var OurPartners_BubbleLogoRunnerMobile = (BubbleLogoRunnerMobile);
BubbleLogoRunnerMobile.defaultProps = {};
;// CONCATENATED MODULE: ./components/templates/offshore/about-us/OurPartners/index.js








var Component = function Component(_ref) {
  var title = _ref.title,
      description = _ref.description,
      button = _ref.button;
  // ******
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "row",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "text-center lg:text-left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        className: "title-h2 mb-6 pb-0 font-bold text-bbc-brand-800",
        text: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-6 lg:hidden",
        children: description
      }), button && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
          href: "/become-our-partner",
          className: "inline-block rounded-[50px] bg-bbc-primary py-2 px-6 text-center text-base font-semibold text-white transition-all hover:bg-bbc-brand-600",
          children: "Become Our partner"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden lg:block",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
        height: 430,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(OurPartners_BubbleLogoRunner, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "block lg:hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
        height: 430,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(OurPartners_BubbleLogoRunnerMobile, {})
      })
    })]
  });
};

/* harmony default export */ var OurPartners = (Component);
Component.defaultProps = {
  title: "",
  description: "",
  button: false
};
;// CONCATENATED MODULE: ./components/templates/offshore/about-us/WhoWeServes/index.js


function WhoWeServes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function WhoWeServes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WhoWeServes_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WhoWeServes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var ServiceCard = function ServiceCard(_ref) {
  var service = _ref.service,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6 flex h-full w-full flex-1 flex-col items-center justify-center bg-bbc-gradient-6 px-3 shadow-[0px_4px_8px_rgba(0,0,0,0.1)] lg:mb-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, WhoWeServes_objectSpread({
          className: "py-20"
        }, service === null || service === void 0 ? void 0 : service.image))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-10 text-left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: service === null || service === void 0 ? void 0 : service.title,
          as: "h3",
          className: "group-hover:text-primary text-lg font-semibold leading-relaxed text-bbc-brand-700 line-clamp-2 ".concat(service !== null && service !== void 0 && service.description ? "mb-6" : "")
        }), (service === null || service === void 0 ? void 0 : service.description) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: "text-black",
          children: [service.description, " ", service.link ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: service.link.url,
            rel: "noreferrer",
            className: "font-medium text-bbc-primary hover:text-bbc-secondary-300",
            children: service.link.summary
          }) : ""]
        })]
      })]
    })
  });
};

var WhoWeServes = function WhoWeServes(_ref2) {
  var title = _ref2.title,
      subTitle = _ref2.subTitle,
      partners = _ref2.partners;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container relative z-10 text-center lg:text-left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        text: title,
        className: "title-h2 mb-2 text-bbc-30px text-bbc-brand-800 lg:text-bbc-40px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        text: subTitle,
        className: "title-h2 mb-6 text-bbc-30px text-bbc-brand-700 lg:text-4xl lg:leading-[50px]"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "row justify-center lg:justify-between",
        children: partners.length > 0 && partners.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceCard, {
            service: item,
            className: "md:col-8 lg:col-4"
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var about_us_WhoWeServes = (WhoWeServes);
WhoWeServes.defaultProps = {
  title: "",
  subTitle: "",
  partners: []
};
;// CONCATENATED MODULE: ./components/templates/offshore/about-us/index.js









/** ========== */





var about_us_Component = function Component(_ref) {
  var dataJson = _ref.dataJson;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: " banner-fix-min-h-569",
      breadcrumbs: dataJson === null || dataJson === void 0 ? void 0 : dataJson.breadcrumbs,
      title: "Your trusted partner in company formation and management",
      titleProps: {
        className: "banner-default-title mb-6 capitalize",
        textColor: "banner-title-default-color"
      },
      leftClassName: "lg:col-6",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/offshore/about-us/banner-offshore-aboutus.png",
        wrapper: {
          className: "bbc-banner-image-country xl:top-24 pb-0 "
        },
        className: "h-full w-full",
        width: 464,
        height: 439,
        alt: "banner-img"
      }),
      bgColor: "bg-bbc-gradient-service"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: "section-our-story",
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-6 pb-0 text-center text-bbc-brand-800 lg:text-left",
          children: "Our Story"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-6",
          children: "BBCIncorp Limited was established in 2017 with a mission to help startups and SMEs to free their resources tied up to intimidating company administration tasks, and thus speed up the process of setting up and running a business, unleashing their potential power for growth and expansion."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-6",
          children: "Our services are specialized in company formation, banking assistance, accounting & auditing, legal administration and much more in 20 countries across the globe."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-6",
          children: "Our proven IT strategy with the usage of technology advancement along with long-term sustainable relationships in the industry allow us to deliver services at scale with minimum costs. Wherever you want to initialize your business, BBCIncorp can help to accelerate the process in a reliable and successful manner."
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: "section-who-we-serves",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(about_us_WhoWeServes, {
        title: "Who",
        subTitle: "We Serve?",
        partners: dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataWhoWeServe
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyChooseUs/* default */.Z, {
      title: "What Makes Us Different",
      sectionClassName: "bg-bbc-gradient-2 mt-10 lg:mt-20 py-10 lg:py-20",
      data: dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataWhyMakeUs
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: "section-our-core-values",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(about_us_OurCoreValues, {
        title: dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataOurCoreValues.title,
        description: dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataOurCoreValues.description,
        data: dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataOurCoreValues.data
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: "section-say-about-bbcincorp",
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "m-auto lg:col-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "title-h2 mb-6 pb-0 text-center text-bbc-brand-800",
            children: "What customers say about BBCIncorp"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-center",
            children: "Our skillful secretary have helped thousands of businesses like yours with their corporate governance."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrustpilotFeedBack/* default */.Z, {
            data: data/* feedback */.I
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-10 lg:mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(OurPartners, {
          title: "Our Partners",
          description: "Join our expanding network of inter-industry professionals in business solutions and gain a competitive edge."
        })
      })
    })]
  });
};

/* harmony default export */ var about_us = (about_us_Component);

/***/ }),

/***/ 29850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Index_avatar__N4Fw5","btnNext":"Index_btnNext__swLTJ","btnPrev":"Index_btnPrev__KZ1Lh"};

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 54356:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"I":[{"name":"Georgi Karov","avatar":"GK","bgAvatar":"#e6f5ee","title":"Lightning fast and precise service!","content":"In my nearly a quarter of century practice, I can hardly name other than BBCIncorp corporate services company with such an instant and straight to the point response with so solid grasp on the needs of the client.","stars":5},{"name":"Siddhant Choyal","avatar":"SC","bgAvatar":"#9df5cc","title":"My #1 recommendation for company registrations","content":"Daisy will guide you through everything and reply almost instantly 100% of the times. If you\'re looking got a HK LTD company, BBCIncorp would be my #1 recommendation. They do above and beyond, it was an absolute breeze working with them.","stars":5},{"name":"Georgi Karov","avatar":"GK","bgAvatar":"#dfeef5","title":"Lightning fast and precise service!","content":"In my nearly a quarter of century practice, I can hardly name other than BBCIncorp corporate services company with such an instant and straight-to-the-point response with so solid grasp on the needs of the client.","stars":5},{"name":"Suraj","avatar":"SU","bgAvatar":"#bfd7e3","title":"Best Service !","content":"I had the pleasure of dealing with Daisy to incorporate my company, the staff at BBCincorp are professional, knowledgable and cost-effective! best service, best price and extremely competent. Would recommend it again !","stars":5},{"name":"Hasitha Dissanayake","avatar":"HD","bgAvatar":"#cdcfc8","title":"Thanks to Laura and the team for their…","content":"Thanks to Laura and the team for their professionalism and responsiveness to assist us in our company formation and bank account opening, can recommend them to anyone.","stars":5},{"name":"Michael Stoeckle","avatar":"MS","bgAvatar":"#cccfc8","title":"Great job is done by BBCIncorp","content":"The team from BBCIncorp was very fast in responding; I had an active and fruitful dialogue while the company was set up: The new venture was fully operational in less than a week which is great.","stars":5},{"name":"Jeremy","avatar":"JE","bgAvatar":"#f4fcc5","title":"Very good company","content":"Very good company. You can trust them. Frankly, this is the first time I have had to deal with a competent accountant. It changes greatly from France ^^. I had lost hope that a competent accountant existed in this world. BBCincorp gave me hope","stars":5},{"name":"Frank Duffy","avatar":"FD","bgAvatar":"#cef4f5","title":"I found BBCIncorp very easy to deal with…","content":"I found BBCIncorp very easy to deal with, they explained everything in detail from the beginning and answered any queries I had very quickly. They were efficient, pleasant to work with & I would have no problem recommending them to anyone.","stars":5},{"name":"Andrii Ch","avatar":"AC","bgAvatar":"#cef6f4","title":"Highly professional and responsive experts","content":"BBC Incorp is one of a kind international legal consultant and advisor of the highest caliber. I especially recommend working with Mrs. Linda Chen, who is a first-class legal specialist.","stars":5}]}');

/***/ })

}]);